/* This is a high order version of the MenuOwner mixin for use with ES6 class syntax
*	 example use -
*	 export default DimensionAware(MyComponent)
*/
import { debounce, omit } from 'lodash'
import React from 'react'
import ReactDOM from 'react-dom'
import T from 'prop-types'
import getBaseClass from './getBaseClass'

export default WrappedComponent => {
  const BaseClass = getBaseClass(WrappedComponent)

  class DimensionAware extends BaseClass {
    static displayName = `DimensionAware(${WrappedComponent.displayName ||
      'Component'})`

    static propTypes = {
      dimensionUpdateDebounceTime: T.number, //ms
      getRef: T.func // TODO remove and use regular refs when React addresses the issues at the end of this https://facebook.github.io/react/docs/higher-order-components.html
    }

    static defaultProps = {
      dimensionUpdateDebounceTime: 200 // ms
    }

    constructor(props) {
      super(props)
      this.state = {
        measuredHeight: 10,
        measuredWidth: 10,
        // windowHeight: 10,
        // windowWidth: 10
      }
    }

    UNSAFE_componentWillMount() {
      //This duration should be short, anything over 250 causes weird rendering
      // on the Connection graph in chrome
      const duration = this.props.dimensionUpdateDebounceTime
      this._throttledResize = debounce(this._handleResize, duration)
      window.addEventListener('resize', this._throttledResize)
    }

    componentDidMount() {
      this._handleResize()
    }

    componentWillUnmount() {
      this._isUnmounting = true
      if (this._throttledResize) {
        window.removeEventListener('resize', this._throttledResize)
        delete this._throttledResize
      }
    }

    _handleResize = () => {
      if (!this._isUnmounting) {
        const state = this.state
        const dims = this.getDims()
        if (dims.measuredWidth !== state.measuredWidth || dims.measuredHeight !== state.measuredHeight) {
          this.setState(dims)
        }
      }
    }

    getDims = () => {
      // TODO optionally (via props) provide full output of getBoundingClientRect?
      const selfEl = ReactDOM.findDOMNode(this)
      const h = selfEl.offsetHeight
      const w = selfEl.offsetWidth

      return {
        measuredHeight: Math.max(h, 10),
        measuredWidth: Math.max(w, 10)
      }
    }

    render() {
      const {height, width} = this.props
      const {measuredHeight, measuredWidth} = this.state
      const refProps = {}
      refProps[
        WrappedComponent.propTypes && WrappedComponent.propTypes.getRef
          ? 'getRef'
          : 'ref'
      ] = this.props.getRef
      const childProps = omit(this.props, isDefinedCmpProp)

      return (
        <WrappedComponent
          {...refProps}
          {...childProps}
          height={height || measuredHeight}
          width={width || measuredWidth}
        />
      )
    }
  }

  const isDefinedCmpProp = (val, key) => DimensionAware.propTypes.hasOwnProperty(key)

  return DimensionAware
}